import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class DownloadFilesService {

  constructor(private httClient: HttpClient) { }

  downloadFile(url: string, fileName:string):void {
    this.httClient.get(url, {responseType: 'blob'}).subscribe((data) => {
      saveAs(data, fileName)
    }

    )
  }
}
